export default "__VITE_ASSET__f7e9ab3b__"